/* tslint:disable */
/* eslint-disable */
/**
 * API Gateway
 * This API provides user authentication and profile management.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 *
 * @export
 */
export const V1SMSeries = {
    V1WorkoutHistory: 'v1WorkoutHistory',
    V1ProgrammeCompletion: 'v1ProgrammeCompletion',
    V1ProgrammeExcerciseComplexity: 'v1ProgrammeExcerciseComplexity',
    V1CommunityWorkoutPlanRequest: 'V1CommunityWorkoutPlanRequest',
    V1Followers: 'v1Followers',
    V1WorkoutTrends: 'v1WorkoutTrends',
    V1WorkoutShoutOut: 'v1WorkoutShoutOut',
    V1CoachEngagement: 'v1CoachEngagement',
    CoachRequestStats: 'coachRequestStats',
    RequestMessageStats: 'requestMessageStats',
    CoachClientStats: 'coachClientStats'
} as const
export type V1SMSeries = (typeof V1SMSeries)[keyof typeof V1SMSeries]

export function instanceOfV1SMSeries(value: any): boolean {
    for (const key in V1SMSeries) {
        if (Object.prototype.hasOwnProperty.call(V1SMSeries, key)) {
            if (V1SMSeries[key as keyof typeof V1SMSeries] === value) {
                return true
            }
        }
    }
    return false
}

export function V1SMSeriesFromJSON(json: any): V1SMSeries {
    return V1SMSeriesFromJSONTyped(json, false)
}

export function V1SMSeriesFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean
): V1SMSeries {
    return json as V1SMSeries
}

export function V1SMSeriesToJSON(value?: V1SMSeries | null): any {
    return value as any
}

export function V1SMSeriesToJSONTyped(
    value: any,
    ignoreDiscriminator: boolean
): V1SMSeries {
    return value as V1SMSeries
}
